export enum ViewMode {
    Interactive,
    PrintPreview
}
